import React from 'react'
import Footer from '@components/home/footer'
import Hero from '@components/about/hero'
import Values from '@components/about/Values'
import Why from '@/components/about/Why'
import OurMission from '@/components/about/OurMission'
import CTA from '@/components/cta' 
import TestimonialBar from '@/components/home/testimonialBar'
import BeanCounting from '@/components/about/BeanCounting'
import Header from '@/components/header'
import Seo from '@/components/seo'

const About = () => {
  return (
    <>
      <Seo
        title="About Us | Pinto Financial"
        description="All About Pinto, Who We are and Why We Do What We Do. Learn About Our Vision, Goals and How We Want To Help Transform Small Businesses."
      />

      <div className="">
        <Header />
        <Hero />
        <OurMission />
        <Why />
        <Values />
        <TestimonialBar count={4} />
        <BeanCounting />
        <CTA />
        <Footer />
      </div>
    </>
  )
}

export default About